
import { PropTypes } from 'prop-types';
import RichText from './richText';
import { DecodeHtml } from '../../../utils/decodeHtml';
import { useEffect, useState } from 'react';
import Accordion from '../../campusLife/accordion';
import Event from '../iepre/event';
const Content = ({ richTextContent, accordionsContent, eventContents, downloadButtons, newsContents }) => {

    const [accordion, setAccordion] = useState([])


    useEffect(() => {
        if (accordionsContent != null) {
            setAccordion(
                accordionsContent?.items?.map((item, index) => ({
                    question: item?.content?.properties?.label,
                    answer: item?.content?.properties?.content != null ?
                        DecodeHtml({ html: item?.content?.properties?.content?.items[0]?.content?.properties?.richText?.markup }) :
                        DecodeHtml({ html: item?.content?.properties?.accordionContent?.markup }),
                    open: index === 0
                })
                )
            )
        }


    }, [accordionsContent])



    return (
        <div className='flex flex-col gap-8'>
            {
                richTextContent != null && <RichText text={DecodeHtml({ html: richTextContent?.markup })} />
            }
            {
                accordionsContent != null && <Accordion accordion={accordion} setAccordion={setAccordion} />
            }
            {
                eventContents != null && <Event articles={
                    eventContents?.map((item) => ({
                        link: item?.route?.path
                    }))
                } />
            }
            {
                downloadButtons != null && <div className='flex flex-col gap-4'>
                    {
                        downloadButtons?.items.map((item, index) => (
                            <a key={index} rel='noreferrer' href={item?.content?.properties?.file?.url} target='_blank' className='text-blue-500 underline'>{item?.content?.properties?.label}</a>
                        ))
                    }
                </div>
            }

            {
                newsContents != null && <RichText text={DecodeHtml({ html: newsContents?.items[0]?.content?.properties?.news?.markup })} />
            }
        </div>
    )
}
Content.propTypes = {
    richTextContent: PropTypes.any,
    accordionsContent: PropTypes.any,
    eventContents: PropTypes.any,
    downloadButtons: PropTypes.any,
    newsContents: PropTypes.any
}
export default Content